import React from "react";
import SaveIcon from "@material-ui/icons/Save";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Button } from "react-admin";

interface Props {
  disabled?: boolean;
  saving?: boolean;
  label?: string;
}

const useStyles = makeStyles(
  (theme) => ({
    button: {
      position: "relative",
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    icon: {
      fontSize: 18,
    },
  }),
  { name: "RaSaveButton" }
);

export const CompactSaveButton = ({ disabled, saving, label }: Props) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      type="submit"
      color="primary"
      label={label ?? "ra.action.save"}
      disabled={disabled || saving}
    >
      {saving ? (
        <CircularProgress
          size={18}
          thickness={2}
          className={classes.leftIcon}
        />
      ) : (
        <SaveIcon />
      )}
    </Button>
  );
};
